import { render, staticRenderFns } from "./salesReturn.vue?vue&type=template&id=04f65179&"
import script from "./salesReturn.js?vue&type=script&lang=js&"
export * from "./salesReturn.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports